import { useMonitor } from '../use-monitor';

export function useMonitorApproveActionSubmit() {
  return useMonitor('approve-action-submit');
}
